export default {
  "name": "NCTransfer",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCTransfer",
  "label": "树状表格",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "treeType": {
        "title": "渲染类型",
        "description": "渲染类型",
        "type": "boolean",
        "default": false
      },
      "showSearch": {
        "title": "显示搜索框",
        "description": "显示搜索框",
        "type": "boolean",
        "default": false
      },
      "searchPlaceholder": {
        "title": "搜索框的提示文字",
        "description": "搜索框的提示文字",
        "type": "string"
      },
      "checkable": {
        "title": "显示复选框",
        "description": "显示复选框",
        "type": "boolean",
        "default": true
      },
      "className": {
        "title": "样式名",
        "description": "样式名",
        "type": "string"
      },
      "showMoveBtn": {
        "title": "显示排序按钮",
        "description": "显示排序按钮",
        "type": "boolean"
      },
      "notFoundContent": {
        "title": "列表为空时显示的内容",
        "description": "列表为空时显示的内容",
        "type": "string",
        "default": "暂无数据"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}